module.exports = {
  language: 'German',
  applierApplicationCenter: {
    selectCenterTip: ' '
  },
  multiplePage: {
    moreInfomation: ' ',
    recommendedServices: ' '
  },
  checkoutConfirm: {
    ordered: ' ',
    purchased: ' '
  },
  personal: {
    purgePopupContent:
      'Entschuldigung, Ihre Bewerbung wurde aufgrund von Sicherheitsrichtlinien gelöscht. Sie können uns kontaktieren, wenn Sie sich bald bewerben möchten.'
  },
  login_maximum: {
    errorContent: 'Es tut uns leid, dass Sie heute die maximale Anmeldezeit erreicht haben. Bitte versuchen Sie es am nächsten Tag.'
  },
  nationalityKay: 'de-de',
  noneSelectedText: 'Bitte auswählen',
  multiselect: {
    deselect: 'Drücken Sie Enter zum Entfernen',
    select: 'Drücken Sie Enter zum Auswählen',
    selected: 'Ausgewählt'
  },
  enter: 'Eingeben',
  upload_failed: 'Upload fehlgeschlagen, bitte erneut versuchen',
  due_time: 'Fällige Zeit',
  requirement: 'Anforderung',
  something_went_wrong_please_retry: 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
  valid_rediret_home_page_popup_content: '',
  invalid_rediret_home_page_popup_content:
    'Es ist eine Ausnahme bei der Anmeldung aufgetreten. Versuchen Sie, sich auf der Homepage von [ {country} - {center} ] anzumelden? Wenn ja, klicken Sie bitte auf "Bestätigen"; wenn nein, klicken Sie bitte auf "Abbrechen", um erneut zu wählen.',
  'Temporarily not available': 'Vorübergehend nicht verfügbar',
  'Coming soon': 'Demnächst'
};
